module.exports = import("https://link.springer.com/book/9789811936807");;